import React from 'react';
import { Switch, Route } from 'react-router-dom';

// pages
import Create from './Create';
import List from './List';
import Info from './Info';
import UseList from './UseList';

class Service extends React.PureComponent {
    render() {
        return (
            <Switch>
                <Route exact path='/coupon/add' component={Create} />
                <Route exact path='/coupon/list' component={List} />
                <Route exact path='/coupon/info/:id' component={Info} />
                <Route exact path='/coupon/use/list' component={UseList} />
            </Switch>
        );
    }
}
export default Service;
